import React, { useState, useEffect } from 'react'
import { blindShuffle } from '../utils/SmartLabelUtils'
import 'katex/dist/katex.min.css'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import RadioButtonCheckedRoundedIcon from '@mui/icons-material/RadioButtonCheckedRounded'
import { RectangleContent } from '../UIUtilsFiles/RectangleContent'

function MultipleChoiceImage(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onValueChange,
    onAttemptChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    timerEnd,
    handleSucAndFailFeedback
  } = props
  const {
    ControlID,
    Options,
    Answers,
    Score,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Priority,
    SequenceHint
  } = mcData

  const [value, setValue] = useState('')
  const [sortedChoiceValueArray, setSortedChoiceValueArray] = useState([])

  useEffect(() => {
    let optionsCopy = [...Options]
    if (defaultValue && defaultValue !== '') {
      if (defaultValue.CtlSortedArray) {
        setSortedChoiceValueArray(defaultValue.CtlSortedArray)
      } else {
        setSortedChoiceValueArray(blindShuffle(optionsCopy))
      }
    } else {
      setSortedChoiceValueArray(blindShuffle(optionsCopy))
    }

    if (defaultValue) {
      if (defaultValue.CtlValue) {
        let defaultValueSelected = defaultValue.CtlValue
        setValue(defaultValueSelected)
      }
    } else {
      setValue('')
    }
  }, [defaultValue])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, value)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (value === correctAnswer) {
      onExplanationVisible(true, CorrectAnswerExplanation)
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  function handleOptionChange(optionValue) {
    onAttemptChange(1)
    setValue(optionValue)
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (optionValue === correctAnswer) {
      handleSuccessChange(true)
    } else {
      handleSuccessChange(false)
    }
    validateCorrectAnswer(optionValue)
  }

  function validateCorrectAnswer(optionValue) {
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    //Change priority value
    if (onPriorityChange && followTheFlow && isEmbeded) {
      if (isPractice) {
        if (optionValue === correctAnswer) {
          onPriorityChange(Priority)
        }
      } else {
        onPriorityChange(Priority)
      }
    }
    if (optionValue === correctAnswer) {
      onValueChange(
        ControlID,
        optionValue,
        Score,
        Score,
        sortedChoiceValueArray,
        false
      )
      if (isEmbeded) {
        handleSucAndFailFeedback(true)
      }
    } else {
      onValueChange(
        ControlID,
        optionValue,
        0,
        Score,
        sortedChoiceValueArray,
        false
      )
      if (isEmbeded) {
        handleSucAndFailFeedback(false)
      }
    }
  }

  function renderSelectedIcon(item) {
    if (isPractice || completed === 1 || !isActive) {
      if (value === item.Option) {
        if (value === Options[Answers[0]].Option) {
          return (
            <CheckCircleRoundedIcon
              style={{
                width: '15px',
                height: '15px',
                position: 'absolute',
                right: '5px',
                top: '2px',
                color: '#3EC986'
              }}
            />
          )
        } else {
          return (
            <CancelRoundedIcon
              style={{
                width: '15px',
                height: '15px',
                position: 'absolute',
                right: '5px',
                top: '2px',
                color: '#ff551f'
              }}
            />
          )
        }
      } else {
        return null
      }
    } else {
      if (value === item.Option) {
        return (
          <RadioButtonCheckedRoundedIcon
            style={{
              width: '20px',
              height: '20px',
              position: 'absolute',
              right: '5px',
              top: '2px',
              color: SelectionColor
            }}
          />
        )
      } else {
        return null
      }
    }
  }

  return (
    <div
      className='slide-comp-wrapper row'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
      style={{
        height: isEmbeded ? '50%' : '40%',
        width: isEmbeded ? '100%' : '60%',
        flexDirection: 'row'
      }}
    >
      {sortedChoiceValueArray &&
        sortedChoiceValueArray.map((item, index) => {
          return (
            <div
              className='col-md-6'
              style={{
                height: '100%',
                padding: '1%',
                borderRadius: '8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div
                className='MCImageOptionItemContainer'
                style={{
                  width: isEmbeded ? '100%' : '80%',
                  borderWidth: isVerifyMode
                    ? '3px'
                    : value === item.Option
                    ? '3px'
                    : '1px',
                  borderColor: isVerifyMode
                    ? item.Option === Options[Answers[0]].Option
                      ? '#3EC986'
                      : '#ff551f'
                    : isPractice || completed === 1 || !isActive
                    ? value === item.Option
                      ? value === Options[Answers[0]].Option
                        ? '#3EC986'
                        : '#ff551f'
                      : '#dfdfdf'
                    : value === item.Option
                    ? SelectionColor
                    : '#dfdfdf',
                  borderStyle: 'solid',
                  alignItems: 'center'
                }}
                onClick={() => {
                  if (isPractice && followTheFlow && isEmbeded) {
                    if (value === Options[Answers[0]].Option) {
                    } else {
                      if (completed === 0 && isActive && !explanationClick) {
                        handleOptionChange(item.Option)
                      }
                    }
                  } else {
                    if (completed === 0 && isActive && !explanationClick) {
                      handleOptionChange(item.Option)
                    }
                  }
                }}
              >
                <RectangleContent
                  contentType={'image'}
                  contentData={
                    item.Option === ''
                      ? 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1651&q=80'
                      : item.Option
                  }
                />
                {renderSelectedIcon(item)}
                {/* {isPractice || completed === 1 || !isActive ? (
                  <span>
                    {value === item.Option ? (
                      value === Options[Answers[0]].Option ? (
                        
                      ) : (
                        
                      )
                    ) : undefined}
                  </span>
                ) : (
                  <span>
                    {value === item.Option ? (
                 
                    ) : undefined}
                  </span>
                )} */}
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default MultipleChoiceImage
